module.exports = __webpack_public_path__ + "img/delivery.0afd2613.png";